import { fetch } from '@atlassian/eoc-fetch';

import { type LogSettingsResponseType } from './types';

export const fetchUiSettingsEndpoint = async () => {
	return fetch<LogSettingsResponseType>('/v1/logs');
};
